// 免费三癌早筛及合并样品入口共用的真实机构 ID。
export const jiaJiHuaSpecialOrganizationIds = Object.freeze([
  1633, 1621, 1620, 1619, 1618, 1617, 1613, 1046,
]);

function normalizeOrganizationId(value) {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
}

export function isJiaJiHuaCombinedOrganization(orgId) {
  return jiaJiHuaSpecialOrganizationIds.includes(normalizeOrganizationId(orgId));
}

export function getJiaJiHuaStaffOrganizations() {
  try {
    const stored = JSON.parse(
      localStorage.getItem("medical_university_organizationList") || "[]"
    );
    if (!Array.isArray(stored)) {
      return [];
    }
    const organizations = [];
    const seen = new Set();
    stored.forEach((organization) => {
      const orgId = organization && normalizeOrganizationId(
        organization.id || organization.orgId
      );
      if (orgId && !seen.has(orgId)) {
        seen.add(orgId);
        organizations.push({ ...organization, orgId });
      }
    });
    return organizations;
  } catch (error) {
    return [];
  }
}

export function getJiaJiHuaStaffOrganizationId(query = {}) {
  const organizations = getJiaJiHuaStaffOrganizations();
  const canUse = (id) => id && (
    !organizations.length || organizations.some((org) => org.orgId === id)
  );
  const selectedId = normalizeOrganizationId(
    localStorage.getItem("medical_university_selectedOrgId")
  );
  // 当前切换的机构优先于旧链接，防止切到普通机构后仍沿用特殊页面的 query。
  if (canUse(selectedId)) {
    return selectedId;
  }
  const queryId = normalizeOrganizationId(query.orgId);
  if (canUse(queryId)) {
    return queryId;
  }
  return organizations.length === 1 ? organizations[0].orgId : null;
}
